import { Address } from "./Address";
import { Client } from "./Client";
import { Deliveryman } from "./Deliveryman";
import { Product } from "./Product";
import { Separator } from "./Separator";
import { Store } from "./Store";
import { Voucher } from "./Voucher";

export interface Order {
  _id: string;
  ativo: boolean;
  codigo: string;
  createdAt: string;
  updatedAt: string;
  __v: number;
  status: OrderStatusEnum;
  valor_total: number;
  numeroSacolas?: number;
  cliente: Client;
  endereco_cliente: Address;
  estabelecimento: Store;
  agendado?: boolean;
  dataAgendamento?: string;
  produtos_nao_encontrados?: string;
  solicitacao_cliente_atendida?: boolean;
  nome_separador?: string;
  metodo_pagamento: OrderPaymentMethod;
  detalhes_desconto?: OrderVoucherDetails;
  detalhes_pagamento: OrderPaymentDetails;
  avaliacao?: OrderRate;
  itens: OrderItem[];
  cancelamento?: Cancelamento;
  opcao_falta_estoque: OrderFallbackContact;
  separador?: Separator;
  entregador?: Deliveryman;
  codigoDavGerado?: string;
  itens_trocados?: ChangedItem[];
  itens_peso_alterado?: WeightChangedItem[];
  itens_quantidade_alterada?: QuantityChangedItem[];
  itens_retirados?: RemovedItem[];
  itens_adicionados_separacao?: AddedItem[];
  numeroRepasses?: NumeroRepasses;
  updateStatusAt: string;
  recebidoAt: string;
  separacaoAt?: string;
  separadoAt?: string;
  liberadoAt?: string;
  entregueAt?: string;
  tempoSeparacao?: number;
  tempoEntrega?: number;
}

export enum OrderStatusEnum {
  CREATED = "criado",
  SCHEDULED = "agendado",
  RECEIVED = "recebido",
  IN_SEPARATION = "em_separacao",
  SEPARATED = "separado",
  RELEASED = "liberado",
  IN_DELIVERY = "em_transito",
  ARRIVED = "chegou",
  DELIVERED = "entregue",
  CANCELED = "cancelado",
  FINISHED = "entrega_finalizada",
}

export enum OrderPaymentMethodsEnum {
  PAY_IN_DELIVERY = "pagamento_na_entrega",
  PAY_IN_APP = "pagamento_no_app",
}

export enum OrderPaymentMethodTypesEnum {
  DEBIT = "debito",
  CREDIT = "credito",
  CASH = "dinheiro",
}

export interface OrderPaymentMethod {
  metodo: OrderPaymentMethodsEnum;
  tipo: OrderPaymentMethodTypesEnum;
  descricao: string;
}

export interface OrderVoucherDetails<TVoucher = Voucher> {
  cupom: TVoucher;
  valor_total_inicial: number;
  frete_inicial: number;
}

export interface OrderPaymentDetails {
  gorjeta?: number;
  dinheiro_pago_cliente?: number;
  troco?: number;
  frete: number;
  cpf?: string;
  subtotal: number;
  valor_desconto_cupom?: number;
  valor_taxa_servico?: number;
}

export interface OrderRate {
  avalicao_servico: AvalicaoServico;
  avaliacao_entrega: AvaliacaoEntrega;
  avaliacao_app: AvaliacaoApp;
}

interface AvalicaoServico {
  nota?: number;
  comentario?: string;
  servicos?: string[];
}

interface AvaliacaoEntrega {
  nota?: number;
  chegou?: boolean;
  tempo_atraso?: number;
}

interface AvaliacaoApp {
  nota?: number;
}

export interface OrderItem<T = Product> {
  item: T;
  quantidade: number;
  peso: number;
  qualidade?: string;
  instrucao?: string;
  preco_unitario: number;
  preco_total: number;
}

export enum OrderItemQualityEnum {
  GREEN = "verde",
  NORMAL = "normal",
  MATURE = "maduro",
}

interface Cancelamento {
  justificativa: string;
  status_pedido: string;
}

export interface OrderFallbackContact {
  observacao: string;
  contato_reserva: FallbackContact;
}

interface FallbackContact {
  nome: string;
  telefone: string;
}

export interface ChangedItem {
  item_trocado: Product;
  novo_item: Product;
  quantidade_final: number;
  quantidade_inicial: number;
  peso_inicial: number;
  peso_final: number;
}

export interface WeightChangedItem {
  item_alterado: Product;
  peso_inicial: number;
  peso_final: number;
}

export interface QuantityChangedItem {
  item_alterado: Product;
  quantidade_inicial: number;
  quantidade_final: number;
}

interface RemovedItem {
  item_retirado: Product;
  quantidade: number;
  peso: number;
}

interface AddedItem {
  sku: string;
  nome: string;
  quantidade: number;
  tipo_embalagem: string;
  preco_unitario: number;
  preco_total: number;
}

interface NumeroRepasses {
  entregador: number;
  separador: number;
}
